import actionTypes from '../constants/action-types';

const redirectToStore = () => ({
  type: actionTypes.REDIRECT_TO_STORE,
});

export default redirectToStore;
